var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c(_vm.renderedComponent,_vm._b({tag:"component"},'component',{ content: _vm.content, ..._vm.childProps },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }